import type { FieldDescriptor } from '../types';
import type { FieldRenderState } from './FieldRenderState';
import { FieldSwitch } from './FieldSwitch';

/** A fixed group of fields — {type: "object"} nested under properties. Not repeated. */
export function SectionField({ field, state }: { field: FieldDescriptor; state: FieldRenderState }) {
  return (
    <fieldset className="rounded-lg border p-3">
      <legend className="px-1 text-sm font-semibold">{field.schema.title ?? field.key}</legend>
      <div className="space-y-3">
        {(field.children ?? []).map((child) => (
          <FieldSwitch key={child.path} field={child} state={state} />
        ))}
      </div>
    </fieldset>
  );
}
